export interface SummarizeLink {
  name: string
  icon: string
  href: string
}

// ponytail: best-effort public deep-link patterns for each assistant's web app.
// If a provider changes its query param, fix the base here — one place.
export function buildSummarizeLinks(articleUrl: string, promptPrefix: string): SummarizeLink[] {
  const q = encodeURIComponent(`${promptPrefix} ${articleUrl}`)
  return [
    { name: 'ChatGPT', icon: '/ai-icons/chatgpt.webp', href: `https://chatgpt.com/?q=${q}` },
    { name: 'Claude', icon: '/ai-icons/claude-icon.webp', href: `https://claude.ai/new?q=${q}` },
    { name: 'Perplexity', icon: '/ai-icons/perplexity-icon.webp', href: `https://www.perplexity.ai/search?q=${q}` },
    { name: 'Grok', icon: '/ai-icons/grok-icon.webp', href: `https://grok.com/?q=${q}` },
  ]
}
